import React, { useState, useEffect } from 'react';
import { baseUrl } from '../components/BaseUrl';
import { Link } from 'react-router-dom';
import { MyProSidebarProvider } from "../components/SidebarContext";
import TopBar from '../components/Topbar';
import Footer from '../components/Footer';
import '../App.css';
import axios from 'axios';
import Swal from "sweetalert2";
import GreetUser from '../components/GreetUser';
import AOS from 'aos';
import 'aos/dist/aos.css';

// Material-UI Icons
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import ViewListIcon from '@mui/icons-material/ViewList';
import StarIcon from '@mui/icons-material/Star';
import PeopleIcon from '@mui/icons-material/People';
import ScheduleIcon from '@mui/icons-material/Schedule';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

AOS.init();

const Tracks = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [sortBy, setSortBy] = useState('name');
  const [viewMode, setViewMode] = useState('grid');
  const [showFilters, setShowFilters] = useState(false);

  // Primary blue color scheme
  const primaryBlue = '#0066ff';
  const primaryDark = '#0044cc';
  const primaryLight = '#3399ff';
  const backgroundLight = '#f0f8ff';

  const categories = [
    { id: 'all', name: 'All Tracks' },
    { id: 'web', name: 'Web Development' },
    { id: 'mobile', name: 'Mobile Development' },
    { id: 'data', name: 'Data Science' },
    { id: 'ai', name: 'AI & Machine Learning' },
    { id: 'design', name: 'UI/UX Design' },
    { id: 'business', name: 'Business' }
  ];

  useEffect(() => {
    fetchCourses();
  }, []);

  useEffect(() => {
    filterAndSortTracks();
  }, [data, searchTerm, selectedCategory, sortBy]);

  const fetchCourses = async () => {
    const token = localStorage.getItem("codefussion-login-token");
    setLoading(true);
    axios.get(`${baseUrl}get-tracks.php`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: token
      }
    })
      .then(response => {
        setData(response.data);
        setFilteredData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: "An error occurred. Please try again later",
          icon: "error",
          confirmButtonText: "OK",
          backdrop: `rgba(143, 70, 0, 0.3)`
        });
        setLoading(false);
      });
  };

  const filterAndSortTracks = () => {
    let filtered = [...data];

    // Filter by search term
    if (searchTerm) {
      filtered = filtered.filter(track =>
        track.track_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        track.track_description.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    // Filter by category
    if (selectedCategory !== 'all') {
      filtered = filtered.filter(track =>
        track.track_name.toLowerCase().includes(selectedCategory)
      );
    }

    // Sort tracks
    switch (sortBy) {
      case 'name':
        filtered.sort((a, b) => a.track_name.localeCompare(b.track_name));
        break;
      case 'popular':
        filtered.sort((a, b) => b.id - a.id);
        break;
      case 'newest':
        filtered.sort((a, b) => b.id - a.id);
        break;
      case 'oldest':
        filtered.sort((a, b) => a.id - b.id);
        break;
      default:
        break;
    }

    setFilteredData(filtered);
  };

  const getRandomEnrollment = () => Math.floor(Math.random() * 1000) + 100;
  const getRandomRating = () => (Math.random() * 2 + 3).toFixed(1);
  const getRandomDuration = () => {
    const durations = ['4 weeks', '6 weeks', '8 weeks', '12 weeks'];
    return durations[Math.floor(Math.random() * durations.length)];
  };

  const showCourses = () => {
    try {
      if (filteredData.length === 0) {
        return (
          <div className="no-results">
            <div className="no-results-icon">🔍</div>
            <h3>No tracks found</h3>
            <p>Try adjusting your search or filters</p>
          </div>
        );
      }

      return filteredData.map((item) => {
        const shortenString = item.track_description.substring(0, 80).concat('...');
        const enrollmentCount = getRandomEnrollment();
        const rating = getRandomRating();
        const duration = getRandomDuration();

        if (viewMode === 'list') {
          return (
            <div key={item.id} data-aos="fade-up" data-aos-duration="1000" className="col-12 mb-4">
              <div className="track-card-list">
                <div className="track-image-container">
                  <img src={item.track_image} alt={item.track_name} className="track-image" />
                </div>
                <div className="track-content">
                  <div className="track-header">
                    <h3 className="track-title">{item.track_name}</h3>
                    <div className="track-meta">
                      <span className="meta-item">
                        <StarIcon className="meta-icon" />
                        {rating}
                      </span>
                      <span className="meta-item">
                        <PeopleIcon className="meta-icon" />
                        {enrollmentCount} enrolled
                      </span>
                      <span className="meta-item">
                        <ScheduleIcon className="meta-icon" />
                        {duration}
                      </span>
                    </div>
                  </div>
                  <p className="track-description">{item.track_description}</p>
                  <div className="track-actions">
                    <Link to={`/track-description/${item.id}`}>
                      <button className="btn-enroll" type="button">
                        Explore Track
                        <TrendingUpIcon className="btn-icon" />
                      </button>
                    </Link>
                    <button className="btn-wishlist">
                      <StarIcon className="wishlist-icon" />
                      Save for Later
                    </button>
                  </div>
                </div>
              </div>
            </div>
          );
        }

        // Grid View
        return (
          <div key={item.id} data-aos="fade-up" data-aos-duration="1000" className="col-xl-3 col-lg-4 col-md-6 col-sm-12 mb-4">
            <div className="track-card">
              <div className="card-badge">Popular</div>
              <div className="track-image-container">
                <img src={item.track_image} alt={item.track_name} className="track-image" />
                <div className="image-overlay">
                  <Link to={`/track-description/${item.id}`}>
                    <button className="btn-preview">Quick View</button>
                  </Link>
                </div>
              </div>
              <div className="track-content">
                <h3 className="track-title">{item.track_name}</h3>
                <p className="track-description">{shortenString}</p>
                
                <div className="track-meta-grid">
                  <div className="meta-item">
                    <StarIcon className="meta-icon" />
                    <span>{rating}</span>
                  </div>
                  <div className="meta-item">
                    <PeopleIcon className="meta-icon" />
                    <span>{enrollmentCount}</span>
                  </div>
                  <div className="meta-item">
                    <ScheduleIcon className="meta-icon" />
                    <span>{duration}</span>
                  </div>
                </div>

                <div className="track-progress">
                  <div className="progress-bar">
                    <div className="progress-fill" style={{ width: '75%' }}></div>
                  </div>
                  <span className="progress-text">75% career boost</span>
                </div>

                <div className="track-actions">
                  <Link to={`/track-description/${item.id}`}>
                    <button className="btn-enroll" type="button">
                      Start Learning
                      <TrendingUpIcon className="btn-icon" />
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        );
      });
    } catch (e) {
      return (
        <div className="error-state">
          <div className="error-icon">⚠️</div>
          <h3>Something went wrong</h3>
          <p>We're having trouble loading the tracks. Please try again later.</p>
          <button className="btn-retry" onClick={fetchCourses}>
            Try Again
          </button>
        </div>
      );
    }
  };

  return (
    <MyProSidebarProvider>
      <div className="tracks-page">
        {localStorage.getItem("codefussion-login-token") === null ? window.location.replace("/login") :
          <div>
            <TopBar />
            
            {/* Hero Section */}
            <section className="tracks-hero">
              <div className="hero-container">
                <div className="hero-content">
                  <div className="hero-text">
                    <h1 className="hero-title">Master Your Future</h1>
                    <p className="hero-subtitle">
                      Discover curated learning tracks designed to transform your career. 
                      <span className="highlight"> Start your journey today!</span>
                    </p>
                  </div>
                  
                  {/* Search Bar */}
                  <div className="search-container">
                    <div className="search-box">
                      <SearchIcon className="search-icon" />
                      <input
                        type="text"
                        placeholder="Search tracks by name or description..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="search-input"
                      />
                    </div>
                    <button 
                      className={`filter-toggle ${showFilters ? 'active' : ''}`}
                      onClick={() => setShowFilters(!showFilters)}
                    >
                      <FilterListIcon />
                      Filters
                    </button>
                  </div>

                  {/* Filters Panel */}
                  {showFilters && (
                    <div className="filters-panel">
                      <div className="filter-group">
                        <label>Category</label>
                        <div className="category-filters">
                          {categories.map(category => (
                            <button
                              key={category.id}
                              className={`category-filter ${selectedCategory === category.id ? 'active' : ''}`}
                              onClick={() => setSelectedCategory(category.id)}
                            >
                              {category.name}
                            </button>
                          ))}
                        </div>
                      </div>
                      
                      <div className="filter-group">
                        <label>Sort By</label>
                        <select 
                          value={sortBy} 
                          onChange={(e) => setSortBy(e.target.value)}
                          className="sort-select"
                        >
                          <option value="name">Name (A-Z)</option>
                          <option value="popular">Most Popular</option>
                          <option value="newest">Newest First</option>
                          <option value="oldest">Oldest First</option>
                        </select>
                      </div>

                      <div className="filter-group">
                        <label>View Mode</label>
                        <div className="view-toggle">
                          <button
                            className={`view-btn ${viewMode === 'grid' ? 'active' : ''}`}
                            onClick={() => setViewMode('grid')}
                          >
                            <ViewModuleIcon />
                          </button>
                          <button
                            className={`view-btn ${viewMode === 'list' ? 'active' : ''}`}
                            onClick={() => setViewMode('list')}
                          >
                            <ViewListIcon />
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </section>

            {/* Loading Overlay - Centered on Page */}
            {loading && (
              <div className="loading-overlay">
                <div className="loading-container">
                  <div className="modern-loader">
                    <div className="loader-spinner"></div>
                    <p>Discovering amazing tracks...</p>
                  </div>
                </div>
              </div>
            )}

            {/* Results Section */}
            {!loading && (
              <section className="tracks-results">
                <div className="container">
                  <div className={`tracks-container ${viewMode === 'list' ? 'list-view' : 'grid-view'}`}>
                    <div className="results-header">
                      <h2 className="results-title">
                        Available Tracks 
                        <span className="results-count"> ({filteredData.length})</span>
                      </h2>
                      <div className="results-actions">
                        <span className="showing-text">
                          Showing {filteredData.length} of {data.length} tracks
                        </span>
                      </div>
                    </div>
                    <div className="row">
                      {showCourses()}
                    </div>
                  </div>
                </div>
              </section>
            )}
          </div>
        }
        
        {/* WhatsApp Float */}
        <a href="https://api.whatsapp.com/send?phone=+2348084914979&text=Hello" className="float" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-whatsapp my-float"></i>
        </a>

        <style jsx>{`
          .tracks-page {
            background: ${backgroundLight};
            min-height: 100vh;
            width: 100%;
            top: 0;
            position: relative;
          }

          /* Loading Overlay - Centered on Page */
          .loading-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(240, 248, 255, 0.95);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 9999;
          }

          .loading-container {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;
          }

          .modern-loader {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            text-align: center;
            gap: 20px;
          }

          .loader-spinner {
            width: 60px;
            height: 60px;
            border: 4px solid #e2e8f0;
            border-top: 4px solid ${primaryBlue};
            border-radius: 50%;
            animation: spin 1s linear infinite;
          }

          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }

          .modern-loader p {
            font-size: 1.1rem;
            color: ${primaryBlue};
            font-weight: 600;
            margin: 0;
          }

          /* Hero Section - Reduced Height */
          .tracks-hero {
            background: linear-gradient(135deg, ${primaryBlue} 0%, ${primaryDark} 100%);
            padding: 100px 0 60px;
            color: white;
            top: -50px;
            position: relative;
            overflow: hidden;
          }

          .hero-container {
            width: 100%;
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 20px;
          }

          .hero-content {
            text-align: center;
            width: 100%;
            max-width: 800px;
            margin: 0 auto;
          }

          .hero-text {
            margin-bottom: 40px;
          }

          .hero-title {
            font-size: 3rem;
            font-weight: 800;
            margin-bottom: 20px;
            background: linear-gradient(45deg, #fff, #e0f7ff);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            line-height: 1.1;
          }

          .hero-subtitle {
            font-size: 1.2rem;
            margin-bottom: 0;
            opacity: 0.9;
            line-height: 1.6;
          }

          .highlight {
            color: #ffd700;
            font-weight: 600;
            display: block;
            margin-top: 8px;
          }

          /* Search Container */
          .search-container {
            display: flex;
            gap: 20px;
            max-width: 700px;
            margin: 0 auto;
            align-items: center;
            justify-content: center;
          }

          .search-box {
            flex: 1;
            position: relative;
            background: white;
            border-radius: 25px;
            padding: 0 20px;
            box-shadow: 0 8px 30px rgba(0,0,0,0.15);
            max-width: 500px;
          }

          .search-icon {
            position: absolute;
            left: 20px;
            top: 50%;
            transform: translateY(-50%);
            color: ${primaryBlue};
          }

          .search-input {
            width: 100%;
            padding: 15px 20px 15px 50px;
            border: none;
            background: transparent;
            font-size: 1rem;
            outline: none;
            border-radius: 25px;
          }

          .filter-toggle {
            background: rgba(255,255,255,0.2);
            border: 2px solid rgba(255,255,255,0.3);
            color: white;
            padding: 15px 25px;
            border-radius: 25px;
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 8px;
            transition: all 0.3s ease;
            backdrop-filter: blur(10px);
            font-size: 1rem;
            white-space: nowrap;
          }

          .filter-toggle:hover,
          .filter-toggle.active {
            background: white;
            color: ${primaryBlue};
            transform: translateY(-2px);
          }

          /* Filters Panel */
          .filters-panel {
            background: rgba(255,255,255,0.15);
            backdrop-filter: blur(15px);
            border-radius: 20px;
            padding: 30px;
            margin-top: 40px;
            border: 1px solid rgba(255,255,255,0.2);
            max-width: 800px;
            margin-left: auto;
            margin-right: auto;
          }

          .filter-group {
            margin-bottom: 25px;
          }

          .filter-group label {
            display: block;
            margin-bottom: 12px;
            font-weight: 600;
            font-size: 1rem;
            color: white;
          }

          .category-filters {
            display: flex;
            flex-wrap: wrap;
            gap: 10px;
            justify-content: center;
          }

          .category-filter {
            background: rgba(255,255,255,0.15);
            border: 1px solid rgba(255,255,255,0.3);
            color: white;
            padding: 10px 20px;
            border-radius: 20px;
            cursor: pointer;
            transition: all 0.3s ease;
            font-size: 0.9rem;
          }

          .category-filter:hover,
          .category-filter.active {
            background: white;
            color: ${primaryBlue};
            transform: translateY(-2px);
          }

          .sort-select {
            background: rgba(255,255,255,0.15);
            border: 1px solid rgba(255,255,255,0.3);
            color: white;
            padding: 12px 20px;
            border-radius: 10px;
            width: 100%;
            max-width: 250px;
            outline: none;
            cursor: pointer;
          }

          .sort-select option {
            background: ${primaryBlue};
            color: white;
          }

          .view-toggle {
            display: flex;
            gap: 10px;
            justify-content: center;
          }

          .view-btn {
            background: rgba(255,255,255,0.15);
            border: 1px solid rgba(255,255,255,0.3);
            color: white;
            padding: 12px;
            border-radius: 8px;
            cursor: pointer;
            transition: all 0.3s ease;
          }

          .view-btn:hover,
          .view-btn.active {
            background: white;
            color: ${primaryBlue};
            transform: translateY(-2px);
          }

          /* Results Section */
          .tracks-results {
            padding: 60px 0;
          }

          .container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 20px;
          }

          .results-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 40px;
            flex-wrap: wrap;
            gap: 20px;
          }

          .results-title {
            font-size: 2.2rem;
            font-weight: 700;
            color: #1a202c;
            margin: 0;
          }

          .results-count {
            color: ${primaryBlue};
          }

          .showing-text {
            color: #718096;
            font-size: 0.9rem;
          }

          /* Track Cards */
          .track-card {
            background: white;
            border-radius: 20px;
            overflow: hidden;
            box-shadow: 0 8px 30px rgba(0,0,0,0.08);
            transition: all 0.3s ease;
            position: relative;
            height: 100%;
            display: flex;
            flex-direction: column;
            border: 1px solid #e2e8f0;
          }

          .track-card:hover {
            transform: translateY(-8px);
            box-shadow: 0 20px 40px rgba(0,0,0,0.15);
          }

          .card-badge {
            position: absolute;
            top: 15px;
            right: 15px;
            background: linear-gradient(45deg, ${primaryLight}, ${primaryBlue});
            color: white;
            padding: 6px 15px;
            border-radius: 15px;
            font-size: 0.8rem;
            font-weight: 600;
            z-index: 2;
          }

          .track-image-container {
            position: relative;
            overflow: hidden;
            height: 200px;
          }

          .track-image {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.3s ease;
          }

          .track-card:hover .track-image {
            transform: scale(1.1);
          }

          .image-overlay {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0,0,0,0.7);
            display: flex;
            align-items: center;
            justify-content: center;
            opacity: 0;
            transition: opacity 0.3s ease;
          }

          .track-card:hover .image-overlay {
            opacity: 1;
          }

          .btn-preview {
            background: white;
            color: ${primaryBlue};
            border: none;
            padding: 12px 24px;
            border-radius: 25px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.3s ease;
            font-size: 0.9rem;
          }

          .btn-preview:hover {
            background: ${primaryBlue};
            color: white;
            transform: translateY(-2px);
          }

          .track-content {
            padding: 25px;
            flex: 1;
            display: flex;
            flex-direction: column;
          }

          .track-title {
            font-size: 1.3rem;
            font-weight: 700;
            color: #1a202c;
            margin-bottom: 12px;
            line-height: 1.3;
          }

          .track-description {
            color: #718096;
            line-height: 1.6;
            margin-bottom: 20px;
            flex: 1;
            font-size: 0.95rem;
          }

          .track-meta-grid {
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;
            gap: 10px;
          }

          .meta-item {
            display: flex;
            align-items: center;
            gap: 6px;
            color: #718096;
            font-size: 0.85rem;
          }

          .meta-icon {
            font-size: 1rem !important;
            color: ${primaryBlue};
          }

          .track-progress {
            margin-bottom: 20px;
          }

          .progress-bar {
            background: #e2e8f0;
            border-radius: 10px;
            height: 6px;
            overflow: hidden;
            margin-bottom: 6px;
          }

          .progress-fill {
            background: linear-gradient(45deg, ${primaryLight}, ${primaryBlue});
            height: 100%;
            border-radius: 10px;
            transition: width 0.3s ease;
          }

          .progress-text {
            font-size: 0.8rem;
            color: ${primaryBlue};
            font-weight: 600;
          }

          .track-actions {
            display: flex;
            gap: 12px;
          }

          .btn-enroll {
            background: linear-gradient(45deg, ${primaryLight}, ${primaryBlue});
            color: white;
            border: none;
            padding: 12px 20px;
            border-radius: 10px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.3s ease;
            display: flex;
            align-items: center;
            gap: 8px;
            flex: 1;
            justify-content: center;
            font-size: 0.9rem;
          }

          .btn-enroll:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(0, 102, 255, 0.4);
          }

          .btn-wishlist {
            background: transparent;
            border: 1px solid #e2e8f0;
            color: #718096;
            padding: 10px 16px;
            border-radius: 10px;
            cursor: pointer;
            transition: all 0.3s ease;
            display: flex;
            align-items: center;
            gap: 6px;
            font-size: 0.85rem;
          }

          .btn-wishlist:hover {
            border-color: ${primaryBlue};
            color: ${primaryBlue};
            transform: translateY(-2px);
          }

          /* List View */
          .track-card-list {
            background: white;
            border-radius: 20px;
            overflow: hidden;
            box-shadow: 0 8px 30px rgba(0,0,0,0.08);
            transition: all 0.3s ease;
            display: flex;
            border: 1px solid #e2e8f0;
          }

          .track-card-list:hover {
            transform: translateY(-5px);
            box-shadow: 0 15px 40px rgba(0,0,0,0.12);
          }

          .track-card-list .track-image-container {
            width: 300px;
            height: auto;
            flex-shrink: 0;
          }

          .track-card-list .track-content {
            flex: 1;
            padding: 30px;
          }

          .track-card-list .track-header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 15px;
            flex-wrap: wrap;
            gap: 15px;
          }

          .track-card-list .track-meta {
            display: flex;
            gap: 20px;
            flex-wrap: wrap;
          }

          .track-card-list .meta-item {
            background: #f7fafc;
            padding: 8px 16px;
            border-radius: 10px;
            display: flex;
            align-items: center;
            gap: 6px;
            font-size: 0.85rem;
          }

          /* No Results & Error States */
          .no-results, .error-state {
            text-align: center;
            padding: 80px 20px;
            grid-column: 1 / -1;
          }

          .no-results-icon, .error-icon {
            font-size: 4rem;
            margin-bottom: 20px;
          }

          .btn-retry {
            background: ${primaryBlue};
            color: white;
            border: none;
            padding: 12px 30px;
            border-radius: 10px;
            cursor: pointer;
            font-weight: 600;
            margin-top: 20px;
            transition: all 0.3s ease;
          }

          .btn-retry:hover {
            background: ${primaryDark};
            transform: translateY(-2px);
          }

          /* Responsive Design */
          @media (max-width: 1200px) {
            .track-card-list .track-image-container {
              width: 250px;
            }
            
            .hero-title {
              font-size: 2.8rem;
            }
          }

          @media (max-width: 992px) {
            .tracks-hero {
              padding: 80px 0 50px;
            }

            .hero-title {
              font-size: 2.4rem;
            }
            
            .hero-subtitle {
              font-size: 1.1rem;
            }
            
            .track-card-list .track-image-container {
              width: 200px;
            }
          }

          @media (max-width: 768px) {
            .tracks-hero {
              padding: 70px 0 40px;
            }

            .hero-title {
              font-size: 2.2rem;
            }

            .hero-subtitle {
              font-size: 1rem;
            }

            .search-container {
              flex-direction: column;
              gap: 15px;
            }

            .search-box {
              width: 100%;
            }

            .filter-toggle {
              width: 100%;
              justify-content: center;
            }

            .results-header {
              flex-direction: column;
              align-items: flex-start;
              gap: 15px;
            }

            .results-title {
              font-size: 1.8rem;
            }

            .track-card-list {
              flex-direction: column;
            }

            .track-card-list .track-image-container {
              width: 100%;
              height: 200px;
            }

            .track-card-list .track-header {
              flex-direction: column;
              gap: 12px;
            }

            .track-card-list .track-meta {
              gap: 10px;
            }
          }

          @media (max-width: 576px) {
            .tracks-hero {
              padding: 60px 0 30px;
            }

            .hero-title {
              font-size: 2rem;
            }

            .hero-subtitle {
              font-size: 0.95rem;
            }

            .category-filters {
              justify-content: center;
            }

            .track-actions {
              flex-direction: column;
            }

            .filters-panel {
              padding: 20px;
            }

            .track-content {
              padding: 20px;
            }

            .track-card-list .track-content {
              padding: 25px;
            }

            .hero-container {
              padding: 0 15px;
            }
          }

          @media (max-width: 480px) {
            .hero-title {
              font-size: 1.8rem;
            }

            .search-input {
              padding: 12px 15px 12px 45px;
              font-size: 0.9rem;
            }

            .filter-toggle {
              padding: 12px 20px;
              font-size: 0.9rem;
            }

            .category-filter {
              padding: 8px 14px;
              font-size: 0.8rem;
            }

            .track-meta-grid {
              flex-direction: column;
              gap: 8px;
            }

            .results-title {
              font-size: 1.6rem;
            }
          }

          @media (max-width: 360px) {
            .hero-title {
              font-size: 1.6rem;
            }
            
            .hero-subtitle {
              font-size: 0.9rem;
            }
            
            .search-container {
              gap: 12px;
            }
          }
        `}</style>
      </div>
    </MyProSidebarProvider>
  );
};

export default Tracks;